import { useRef, useEffect } from 'react';

export const useAbortController = () => {
  const abortController = useRef(new window.AbortController());

  useEffect(() => {
    const controller = abortController.current;
    return () => {
      controller.abort();
    };
  }, []);

  return abortController.current.signal;
};
